__turbopack_context__.v({
  "className": "geist_mono_354fc78-module__zrY5Sa__className",
});
